import { ApiClientService } from '@dofleini/security';
import { useCallback, useEffect, useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';

export const createPaginationHook = (name, service) => {
  let asyncFn;
  
  switch (typeof service) {
    case 'function':
      asyncFn = service;
      break;
    case 'string':
      asyncFn = params => ApiClientService.post(service, params);
      break;
    default:
      throw new TypeError('Invalid type of service');
  }
  
  return (search, filters, config = {}, queryConfig = {}) => {
    const queryClient = useQueryClient();
    const [page, setPage] = useState(config.page || 1);
    const [size, setSize] = useState(config.size || 10);
    const [sort, setSort] = useState(config.sort);
    
    const fetchData = useCallback(async (page = (config.page || 1)) => {
      const { data, headers } = await asyncFn({ page, size, search, filters, sort });
      const totalPages = Number(headers['x-total-count'] || 0);
      const hasMore = data.length === size;
      return { data, totalPages, hasMore };
    }, [config.page, size, search, filters, sort]);
    
    useEffect(() => {
      setPage(config.page || 1);
    }, [search, filters, config.page]);
    
    const {
      status,
      error,
      isFetching,
      isLoading,
      isError,
      refetch,
      data = {},
    } = useQuery([name, page, search, size, sort, filters], () => fetchData(page), {
      ...queryConfig,
      keepPreviousData: true
    });
    
    useEffect(() => {
      if (data?.hasMore) {
        queryClient.prefetchQuery([name, page + 1, search, size, filters], () => fetchData(page + 1));
      }
      
      if (!isLoading && !data?.data?.length && page > 1) {
        setPage(1);
      }
    }, [page, size, search, filters, fetchData, queryClient, data, isLoading]);
    
    return {
      page,
      status,
      ...data,
      error,
      isFetching,
      isLoading,
      isError,
      refetch,
      setPage,
      setSize,
      setSort,
      size,
      activeKey: [name, page, search, size, filters]
    };
    // Prefetch the next page!
  };
};
